import React from "react";
import styled from "styled-components";
import { ICompany } from "types/interfaces/customers/ICustomer";
import { sanityImgBuilder as builder } from "../sanity";

interface IProps {
  company: ICompany;
  size?: "base" | "small";
  className?: string;
}

const Logo = ({ className, company, size = "base" }: IProps) => {
  // Use a more straightforward approach with explicit fallback
  let imageUrl = "https://via.placeholder.com/28"; // Default fallback

  try {
    if (company.image && "mockImageUrl" in company.image) {
      imageUrl = company.image.mockImageUrl as string;
    } else if (company.image) {
      imageUrl = builder.image(company.image).url();
    }
  } catch (e) {
    console.error("Error generating image URL:", e);
  }

  return (
    <Container className={className}>
      <CompanyLogo src={imageUrl} alt="company-logo" />
    </Container>
  );
};

export default Logo;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const CompanyLogo = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: white;
`;
